module.exports = __webpack_public_path__ + "static/media/JiLin 1.fd4a782c.czml";